







































































































import {Component, Provide, Vue, Prop, Watch} from 'vue-property-decorator';
import AdminLogin from '@/views/Dashboard/AdminLogin.vue';
import NotificationModal from '@/components/NotificationModal.vue';
import {mapActions, mapGetters} from 'vuex';
import {API} from './services/api/api';
import {Utils} from './utils/Utils';
import {isLoggedIn} from './store/getters';
import ShipList from '@/models/shiplist';
import Toasted from 'vue-toasted';
import {getUserNotifications, markAsReadNotification} from '@/services/api/notifications';
import validator from './utils/validator';

@Component({
  methods: {
    ...mapActions([
      'setSideBarVisible',
      'showSuccessToast',
      'showErrorToast',
      'setLoggedIn',
      'setupAppData',
      'setUserDetails',
      'setUserType',
    ]),
  },
  computed: {
    ...mapGetters(['sideBarVisible', 'isLoggedIn', 'showToast', 'getLogo', 'shipList', 'userDetails', 'userType']),
  },
  mounted() {
    const _this: any = this;
    _this.checkSession();
  },
  components: {
    AdminLogin,
    NotificationModal,
  },
})
export default class App extends Vue {
  title = 'SCMS';
  // intervalTime = 1000 * 60 * 3.5;
  intervalTime = 1000 * 60 * 3;
  logoutInterval: any;

  searchInput = '';
  setUserDetails: any;

  //Store vairables
  setUserType: any;
  userType: '';
  setSideBarVisible: any;
  sideBarVisible: any;
  setLoggedIn: any;
  setupAppData: any;
  getLogo: any;
  shipList: ShipList[];
  showSuccessToast: any;
  showErrorToast: any;
  userDetails: {};
  toggleSideMenu = true;
  defaultLogo = require('@/assets/images/logo.png');

  sideMenuIcons = {
    dashboard: require('@/assets/images/dashboard.png'),
    icon4: require('@/assets/images/setting.png'),
    icon5: require('@/assets/images/notepad.png'),
    icon6: require('@/assets/images/category.png'),
    setting: require('@/assets/images/beat.png'),
    more: require('@/assets/images/gear.png'),
    report: require('@/assets/images/chartIcon.png'),
    logout: require('@/assets/images/logout.png'),
  };

  sideMenu = [
    {
      title: 'Admin Panel',
      path: '/admin-panel',
      icon: this.sideMenuIcons.dashboard,
      public: false,
      permissionLevel: 0,
      module: 'adminpanel',
    },
    {
      title: 'Create Inspection',
      path: '/create-inspection',
      icon: this.sideMenuIcons.icon4,
      public: false,
      permissionLevel: 2,
      module: 'inspection',
    },
    {
      title: 'Inspection List',
      path: '/inspection-list',
      icon: this.sideMenuIcons.icon6,
      public: true,
      permissionLevel: 1,
      module: 'inspectionlist',
    },
    {
      title: 'Ship Inspection List',
      path: '/ship-inspection-list',
      icon: this.sideMenuIcons.icon5,
      public: false,
      permissionLevel: 1,
      module: 'inspection',
    },
    {
      title: 'Report',
      path: '/report',
      icon: this.sideMenuIcons.report,
      public: false,
      permissionLevel: 7,
      module: 'report',
    },
    {
      title: 'Action Plan',
      path: '/inspection/action-plan',
      icon: this.sideMenuIcons.setting,
      public: false,
      permissionLevel: 1,
      module: 'action',
    },
  ];
  CSideMenu = [];

  //notification related data
  notification: any = null;
  notificationVisible = false;
  user: any;
  isLoggedIn: any;
  notificationTarget = '#notificationModalCenter';

  //naviagte

  onMenuClick(data) {
    this.toggleSideMenu = !this.toggleSideMenu;
    let element = document.getElementById('navbarNavDropdown');
    let element2 = document.getElementById('navbarId');

    if (element2.classList.contains('collapsed')) {
      element2.classList.remove('collapsed');
    } else element2.classList.add('collapsed');

    if (element.classList.contains('show')) {
      element.classList.remove('show');
    }
    this.$router.push(data.path);
  }

  //global logout
  async logout() {
    this.cleanUp();
    this.setLoggedIn(false);
    this.setUserDetails({
      // data: {},
      // type: {
      //   roleId: null,
      //   name: '',
      // },
      // permissions: {},
    });
    this.setSideBarVisible(false);
    sessionStorage.clear();
    this.notificationTarget = null;
  }

  //global login watcher
  @Watch('isLoggedIn')
  updateView(isLoggedIn: boolean, oldValue: boolean) {
    const currPath = this.$router.currentRoute.path;
    if (isLoggedIn) {
      this.notificationTarget = '#notificationModalCenter';
      this.setSideBarVisible(true);
      if (currPath !== '/') this.$router.push('/');
      if (!this.logoutInterval) this.checkSession();
    } else {
      if (currPath !== '/login') this.$router.replace('/login');
    }
  }

  //check if token is still valid or not
  async checkSession() {
    if (!Utils.isUserLoggedIn()) {
      this.setLoggedIn(false);
    }
    const tokenValid = await API.userRefreshToken();
    if (!tokenValid) {
      await this.logout();
    } else {
      this.setLoggedIn(true);
      this.logoutInterval = setInterval(async () => {
        const tokenValid = await API.userRefreshToken();
        if (!tokenValid) await this.logout();
      }, this.intervalTime);
    }
  }
  cleanUp() {
    if (this.logoutInterval) {
      clearInterval(this.logoutInterval);
      this.logoutInterval = null;
    }
  }

  //notification stuff
  //Global watcher for toast
  @Watch('showToast')
  showToastGlobal(showToast) {
    let msg = showToast.msg;
    let title = showToast.title;
    let varient = showToast.color;
    this.$toasted.show(msg, {
      theme: 'toasted-primary',
      position: 'top-center',
      duration: 5000,
      type: varient,
    });
  }

  // loggedIn watcher
  @Watch('isLoggedIn')
  async checkNotifications(isLoggedIn: boolean, oldValue: boolean) {
    if (isLoggedIn) {
      try {
        let data = sessionStorage.getItem('user');
        const user = data ? JSON.parse(data) : null;
        let userType = user.internal[0].group.groupId;
        let canAccess = userType == process.env?.VUE_APP_ADMIN_ID || userType == process.env?.VUE_APP_SUPER_ADMIN_ID;

        if (user && canAccess) {
          this.user = user;
          const notifications: any[] = await getUserNotifications(user.internalId);
          if (notifications.length) {
            let index = 0;
            const interval = setInterval(() => {
              let internalData = sessionStorage.getItem('user');
              const user = internalData ? JSON.parse(internalData) : null;
              if (user) {
                if (!this.isModalVisible()) {
                  this.notification = notifications[index++];
                  if (!this.notification) clearInterval(interval);
                  this.showNotificationAndSetTimer(this.notification, user.internalId);
                }
              }
            }, 5000);
          }
        } else {
          return;
        }
      } catch (e) {
        console.error(e);
      }
    }
  }

  // userDetails watcher
  @Watch('isLoggedIn', {deep: true, immediate: true})
  validateUser(userDetails) {
    if (!userDetails.hasOwnProperty('data')) {
      this.getUserDetails();
    } else {
      this.setupAppData();
      this.getSideMenu(this.userDetails);
    }
  }

  // get logged-in user details on page refresh
  async getUserDetails() {
    let data = sessionStorage.getItem('user');
    const user = data ? JSON.parse(data) : null;

    if (user !== null) {
      try {
        let apiResponse = await API.getUserById(user.userId);
        //
        if (apiResponse.data) {
          const data = apiResponse.data;
          let userDetails;
          userDetails = {data};
          // this.setUserDetails({
          //   data: data,
          // });
          if (data.internal[0]) {
            let userType = data.internal[0].group.groupName.trim();
            userDetails = {
              ...userDetails,
              type: {
                roleId: data.internal[0].group.groupId,
                name: userType,
              },
            };
            // this.setUserDetails({
            //   type: {
            //     roleId: data.internal[0].group.groupId,
            //     name: userType,
            //   },
            // });
          }
          if (data.authorities) {
            let permissions = data?.authorities?.groupAuthorities;
            userDetails = {
              ...userDetails,
              permissions: permissions,
            };
            // this.setUserDetails({
            //   permissions: permissions,
            // });
          }
          this.setUserDetails({...userDetails});
          this.getSideMenu(JSON.parse(JSON.stringify({...userDetails})));
        } else {
          this.showErrorToast({msg: apiResponse.error});
        }
      } catch (error) {
        this.showErrorToast({msg: 'Network error'});
      } finally {
        // thisScreenLoadingis. = false;
      }
    } else {
      await this.$router.push('/login');
    }
  }

  //show notification
  async showNotificationAndSetTimer(data, userId) {
    if (!data) return;

    this.$notify({
      title: data.newsHeading,
      text: data.newsDescription,
      type: 'success',
      duration: 5000,
    });
  }

  //mark notification as read
  async clearNotification(newsId) {
    await markAsReadNotification(this.user.internalId, newsId);
  }

  isModalVisible() {
    const classes = document.body.className;
    this.notificationVisible = classes.includes('modal-open');
    return this.notificationVisible;
  }

  //Global search
  searchInputMethod() {
    if (this.searchInput) {
      const ship = this.shipList.find(
        (ship) => ship.name.trim().toLowerCase() == this.searchInput.trim().toLowerCase()
      );
      if (ship) {
        this.$router.replace('/ship-inspection-list/' + ship.shipId);
        this.searchInput = '';
      } else {
        this.showErrorToast({
          msg: 'Ship not found with name: ' + this.searchInput,
        });
      }
    }
  }

  //display side menu based on role and permission
  // @Watch('userDetails', {deep: true, immediate: true})
  getSideMenu(userDetails = null) {
    if (userDetails?.data) {
      let userRoleId = userDetails?.type?.roleId;
      let modifySidebar = this.sideMenu.filter((me) => {
        if (userRoleId == process.env?.VUE_APP_SUPER_ADMIN_ID) return me;
        else {
          if (me.public) return true;
          return (
            (me.path === '/admin-panel' && userRoleId == process.env?.VUE_APP_ADMIN_ID) ||
            (me.path !== '/admin-panel' && Utils.manageRoutePermissions(me.module, me.permissionLevel))
          );
        }
      });
      this.CSideMenu = [...modifySidebar];
    } else {
      this.CSideMenu = [];
    }
  }
}
